import { Link, useNavigate } from "react-router-dom";
import ellowLogo from "../../assets/images/ellow-logo.svg"; 
import ellowLogoIcon from "../../assets/images/ellow-logo-icon.svg"; 
import { Icon } from "@iconify/react"; 
import Styles from "./styles.module.scss";
import Button from "../../compopnents/button";
import classnames from "classnames"; 
import { Auth } from "aws-amplify";
import { LOGIN } from "../../navigation/CONSTANTS";
import { useEffect, useState } from "react";
import ConfirmationModal from "../../modal/confirmation/confirmationModal";


interface Props {
  menu?: { icon: string, title: string, url: string, active: boolean }[],
  openresource?: string
}


const SideMenu: React.FC<Props> = ({
  menu = [],
  openresource
}) => {

  let customerMetdata: any = {};
  const storedData = localStorage.getItem("customerMetdata");
  if (storedData) {
    try {
     customerMetdata = JSON.parse(storedData);
    } catch (error) {
      console.error("Error parsing customerMetadata:", error);
    }
  }
  console.log('customerMetdata', customerMetdata);
  

  const navigate = useNavigate();
const [fullname, setFullName] = useState<any>()
  const [companyName, setCompanyName] = useState<string>('')
  const [logoutModal, setLogoutModal] = useState<boolean>(false)
  useEffect(() => {
    if (customerMetdata) {
      setFullName(customerMetdata.firstName)
      setCompanyName(customerMetdata.companyName)
  }
  if (openresource) {
    setShow((prev => !prev))
  }  
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [])



async function logout() {
  try {
    await Auth.signOut();
    localStorage.clear();
    navigate('/customerlogin')
  } catch (error) {
      
  }
}
 

const handleClick = () => {
  document.body.classList.toggle('expandSideMenu');
};


// const subMenuClick = () => {
//   document.body.classList.toggle('expandSubMenu');
// }

const [show, setShow] = useState<boolean>(false);
 
  return (
    <aside className={classnames(Styles.sideMenu, "sideMenu")}>
      {logoutModal && <ConfirmationModal reject={false} submit={logout} onClose={() => setLogoutModal(false)} />}
      <div className={Styles.sideMenuWrap}>
        <div className={classnames(Styles.header, "header")}>
          <img src={ellowLogo} className={classnames(Styles.logo, "logo")} alt="ellow.io"/>
          <img src={ellowLogoIcon} className={classnames(Styles.icon, "icon")} alt="ellow.io"/>
          <button onClick={handleClick}><Icon icon="ep:arrow-right-bold" /></button>
        </div>
        <div className={classnames(Styles.userInfo, "userInfo")}>
          <figure>
            {console.log('fullname', fullname)}
            {fullname && fullname[0] + fullname[1]}
          </figure>
          <figcaption>{ fullname }</figcaption>
          <div className={Styles.role}>{companyName}</div>
        </div>
        {/* <nav>
          <Link to="" className={Styles.active} onClick={hideMobileMenu}><Icon icon="lucide:home" />Dashboard</Link>
          <Link to='/createPositions' className={Styles.active} onClick={hideMobileMenu}><Icon icon="ant-design:crown-outlined" />Positions</Link>
          <Link to='/resources'  className={Styles.active} onClick={hideMobileMenu}><Icon icon="heroicons-outline:users" />Resources</Link>
          <Link to=""><Icon icon="cil:building" />Company</Link>
          <Link to=""><Icon icon="lucide:book-open" />Reports</Link>
          <Link to=""><Icon icon="ci:bar-chart-alt" />Summary Reports</Link>
        </nav> */}
          <nav>
          {menu.map((item, key) =>
            <Link to={item.url} className={item.active ? Styles.active : ""} key={key} >
            <Icon icon={item.icon}  />
            <span>
            {item.title}
            </span>
            </Link>
          )
          }
        </nav>
           {/* <div key={key} className={`subMenu ${show ? "active" : ""}`}>
              <Link to={item.url} onClick={item.title === 'Resources' ? () => { setShow((prev) => !prev);  }
             : undefined} className={item.active ? Styles.active : ""}><Icon icon={item.icon} /><span>{item.title} { item.title === 'Resources' && <Icon icon="ep:arrow-down-bold" />}</span></Link>
            {item.title === 'Resources' && item.active && <div className={classnames(Styles.subLinks, "subLinks")}>
                <Link to='/resources' className={openresource === 'allresources' ? "active" : ""}><span>All</span></Link>
                <Link to='/incontract'className= {openresource === 'incontract' ? "active" : ""}><span>In Contract</span></Link>
                <Link to='/rejected'className= {openresource === 'rejected' ? "active" : ""}><span>Rejected</span></Link>
                <Link to='/blacklisted'className= {openresource === 'blacklisted' ? "active" : ""}><span>Blacklisted</span></Link>
            </div>}
          </div> */}
 

        <div className={Styles.referBtn}>
          {/* <Button onClick={[]} variant="primary"><Icon icon="bx:gift" />Refer & Earn</Button> */}
        </div>
      </div>
      <nav>
        <Link to={''} onClick={()=> setLogoutModal(true)}>
          <Icon icon="ic:twotone-logout" />
          <span>Logout</span>
        </Link>
      </nav>
    </aside>
  );
}

export default SideMenu;
